import { isEmpty } from "lodash";
export const breadcrumbs = (data = null, staticList = []) => {
    var breadcrumbs = []
    if (!isEmpty(data?.parent)) {
   
        if (!isEmpty(data?.parent?.parent?.parent)) {
            breadcrumbs.push({ label: data?.parent?.parent?.parent?.label, url: `/${data?.parent?.parent?.parent?.slug}`,  link_type:data?.parent?.parent?.parent?.link_type})
            if (data?.parent?.parent?.link_type) {
                breadcrumbs.push({ label: data?.parent?.parent?.label, url: `/${data?.parent?.parent?.parent?.slug}/${data?.parent?.parent?.slug}`, link_type:data?.parent?.parent?.link_type })
            }
            if (data?.parent?.link_type) {
                breadcrumbs.push({ label: data?.parent?.label, url: `/${data?.parent?.parent?.parent?.slug}/${data?.parent?.parent?.slug}/${data?.parent?.slug}`, link_type:data?.parent?.link_type })
            }
        } else if (!isEmpty(data?.parent?.parent)) {
            breadcrumbs.push({ label: data?.parent?.parent?.label, url: `/${data?.parent?.parent?.slug}`, link_type:data?.parent?.parent?.link_type })
            if (data?.parent?.link_type) {
                breadcrumbs.push({ label: data?.parent?.label, url: `/${data?.parent?.parent?.slug}/${data?.parent?.slug}`, link_type:data?.parent?.link_type })
            }
            
        } else {
            breadcrumbs.push({ label: data?.parent?.label, url: `/${data?.parent?.slug}`, link_type:data?.parent?.link_type })
        }

    }
    if (!isEmpty(staticList)) {
        staticList.map((item) => (breadcrumbs.push({ label: item.label, url: `/${item.slug}` })))
    }
    if (!isEmpty(data?.label)) {
        breadcrumbs.push({ label: data?.label, url: `/${data?.slug}`, link_type:data?.link_type })
    }
    return breadcrumbs;
}